import axios from 'axios'
import flow from 'lodash/flow'
import appConfig from '@/config'
import { clearErrorByKey, setHeaderFromCookie } from './interceptors/request'
import { followRedirectStatus } from './interceptors/response'
import handleError from './interceptors/error'
import FetchData from './utilities/fetchData'

const api = axios.create(appConfig.api)

const requestInterceptors = flow([
  clearErrorByKey,
  setHeaderFromCookie
])

const responseInterceptors = flow([
  followRedirectStatus
])

api.interceptors.request.use(requestInterceptors)
api.interceptors.response.use(responseInterceptors, handleError)

const fetchData = FetchData(api)

// These helper functions make API requests and return the response
// data when successful.
api.get.data = (url, ...args) => fetchData('get', url, args)
api.put.data = (url, ...args) => fetchData('put', url, args)
api.post.data = (url, ...args) => fetchData('post', url, args)
api.patch.data = (url, ...args) => fetchData('patch', url, args)
api.delete.data = (url, ...args) => fetchData('delete', url, args)

export default api
